module.exports = __webpack_public_path__ + "img/after_ski.3fcd86c9.jpg";